import React from 'react';
import styled from 'styled-components';
import { Skeleton } from 'fpay-ui';

export const Table = styled.div`
  margin-top: 16px;
  padding: 0px 24px;
  height: ${(props) => (props.tableHeight ? '180px' : '350px')};
  overflow-y: auto;
  height: 425px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d6d6d6;
    height: 20px;
    border-radius: 10px;
  }
`;

const Layout = styled.div`
  border-radius: 8px;
  background: var(--gray-gray-25, #fafafa);
  margin-bottom: 16px;
  padding: 0px 8px;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const SkeletonTab = styled(Skeleton)`
  max-width: 97px;
  height: 19px;
  margin-top: 29px;
  margin-bottom: 24px;
`;

const CardSkeleton = () => (
  <>
    <Layout>
      <Row>
        <SkeletonTab />
        <SkeletonTab />
      </Row>
      <Row>
        <SkeletonTab />
        <SkeletonTab />
      </Row>
      <Row>
        <SkeletonTab />
        <SkeletonTab />
      </Row>
      <Row>
        <SkeletonTab />
        <SkeletonTab />
      </Row>
    </Layout>
  </>
);
export default CardSkeleton;
